import { useQuery } from 'react-query';

import {
  SubscriberProfile,
  fetchSubscriber,
  generateSubscriberKey,
} from '../utils/backend-api/subscriber_directory';

export const SUBSCRIBERS_KEY = 'SUBSCRIBERS_KEY';

export default function useSubscriberProfile(username: string, articlePageId: number) {
  const { data: profile, isLoading: isLoadingSubscriberProfile } = useQuery<SubscriberProfile>(
    generateSubscriberKey(username),
    async () => await fetchSubscriber(username, articlePageId)
  );

  return { profile, isLoadingSubscriberProfile };
}
